<selfai-platform-user-functions-list
  [tags]="tags$ | async"
></selfai-platform-user-functions-list>
